/* eslint-disable import/newline-after-import */
/* Combine all available reducers to a single root reducer.
 *
 * CAUTION: When using the generators, this file is modified in some places.
 *          This is done via AST traversal - Some of your formatting may be lost
 *          in the process - no functionality should be broken though.
 *          This modifications only run once when the generator is invoked - if
 *          you edit them, they are not updated again.
 */
/* Populated by react-webpack-redux:reducer */
import { combineReducers } from 'redux';
import newsCategory from '../reducers/customerJourney/newsCategory.js';
import newsCategories from '../reducers/customerJourney/newsCategories.js';
import weather from '../reducers/customerJourney/weather.js';
import login from '../reducers/customerJourney/login.js';
import services from '../reducers/customerJourney/services.js';
import venues from '../reducers/customerJourney/venues.js';
import menu from '../reducers/customerJourney/menu.js';
import attractions from '../reducers/customerJourney/attractions.js';
import eventsCategory from '../reducers/customerJourney/eventsCategory.js';
import eventsCategories from '../reducers/customerJourney/eventsCategories.js';
import categories from '../reducers/customerJourney/categories.js';
import reservation from '../reducers/customerJourney/reservation.js';
import hotel from '../reducers/customerJourney/hotel.js';
import commons from '../reducers/commons.js';
import duringStaySurvey from '../reducers/customerJourney/duringStaySurvey.js';
import { routerReducer } from 'react-router-redux';
import { localeReducer } from 'react-localize-redux';
const reducers = {
  router: routerReducer,
  locale: localeReducer,
  commons,
  hotel,
  reservation,
  categories,
  eventsCategories,
  eventsCategory,
  attractions,
  menu,
  venues,
  services,
  login,
  weather,
  duringStaySurvey,
  newsCategories,
  newsCategory
};
const combined = combineReducers(reducers);
module.exports = combined;



// WEBPACK FOOTER //
// ./reducers/index.js